import PayByLinkBankCodes from '@engine/features/virtual_terminal/vt_update_pay_by_link_bank_codes';
import PayByLinkConsumers from '@engine/features/virtual_terminal/vt_update_pay_by_link_consumers';
import PayByLinkPaymentTypes from '@engine/features/virtual_terminal/vt_update_pay_by_link_payment_types';
import PayByLinkRecurringTypes from '@engine/features/virtual_terminal/vt_update_pay_by_link_recurring_types';
import RequiredFields from '@engine/features/virtual_terminal/vt_update_required_fields';
import { changeCheckboxStatus } from '@engine/lib/utility/change_checkbox_status';
import { exists } from '@engine/lib/utility/exists';
import gateway from '@engine/features/virtual_terminal/vt_gateway';
var $terminalField = $('input[name$="pay_by_link_form[terminal_id]"');

function getTrxTypeStates() {
  return $('.transaction-types-container input:checkbox:checked').map(function (_index, input) {
    return input.id;
  });
}

function isEmailRequired() {
  var $emailField = $('label[for=pay_by_link_transaction_customer_email]');
  return $emailField.hasClass('required') && $terminalField.val();
}

function terminalChangeRequest(action, terminalId, consumerId, customerEmail, selected) {
  $.ajax({
    type: 'GET',
    url: '/pay_by_link/' + action + '/' + terminalId,
    dataType: 'json',
    contentType: 'application/json',
    data: {
      terminal_id: terminalId,
      consumer_id: consumerId,
      customer_email: customerEmail
    }
  }).done(function (data) {
    $('.transaction-types-container').html(data.trx_types);
    $('.gateway-specific-fields-container').html(data.gateway_specific_attributes);
    $('.gateway-specific-fields-container label').addClass('required');
    $('.gateway-specific-fields-container input').attr('required', true);

    if (exists(selected)) {
      changeCheckboxStatus(selected, true);
    }

    if (data.configure_new_managed_recurring) {
      $('.configure-new-managed-recurring-checkbox').removeClass('hidden');
      $('#configure_new_managed_recurring').prop('disabled', false);
      $('#configure_new_managed_recurring').change();
    } else {
      $('.configure-new-managed-recurring-checkbox').addClass('hidden');
      $('#configure_new_managed_recurring').prop('disabled', true);
    }

    if (data.wpf_tokenization_active) {
      $('.remember-card').removeClass('hidden');
      $('#pay_by_link_remember_card').prop('disabled', false);
    } else {
      $('.remember-card').addClass('hidden');
      $('#pay_by_link_remember_card').prop('disabled', true);
    }

    gateway.name = data.gateway_name;
    PayByLinkConsumers.updateFields(data.has_consumers, "".concat(terminalId));
    PayByLinkPaymentTypes.updateFields();
    PayByLinkBankCodes.updateFields();
    PayByLinkRecurringTypes.updateFields();
  });
}

function terminalChange(terminalId) {
  if (terminalId) {
    var consumerId = $('#pay_by_link_consumer_id :selected').val();
    var customerEmail = $('#pay_by_link_transaction_customer_email').val();
    var selected = getTrxTypeStates();
    terminalChangeRequest('update', terminalId, consumerId, customerEmail, selected);
  }
}

function makeSendByFieldRequired() {
  if ($('#send_link_by_email, #send_link_by_none').is(':checked')) {
    RequiredFields.makeFieldRequired('pay_by_link_transaction_customer_email');
    RequiredFields.makeFieldNotRequired('pay_by_link_form_customer_phone');
  } else {
    RequiredFields.makeFieldRequired('pay_by_link_form_customer_phone');

    if (!isEmailRequired()) {
      RequiredFields.makeFieldNotRequired('pay_by_link_transaction_customer_email');
    } else {
      return false;
    }
  }
}

function disableInputForLifetime() {
  $('.payment-lifetime-input').addClass('hidden').find('input').prop('disabled', true);
}

function enableInputForLifetime() {
  $('.payment-lifetime-input').removeClass('hidden').find('input').prop('disabled', false);
}

function toggleLifetimeSelect(isSelectActive) {
  var $lifetimeSelectWrapper = $('.payment-lifetime-select');

  if (isSelectActive) {
    $lifetimeSelectWrapper.removeClass('hidden');
    $lifetimeSelectWrapper.find('#pay_by_link_lifetime_chosen').removeClass('hidden');
    $lifetimeSelectWrapper.find('select, input[type="hidden"]').prop('disabled', false);
    $lifetimeSelectWrapper.find('select').trigger('chosen:updated');
  } else {
    $lifetimeSelectWrapper.addClass('hidden');
    $lifetimeSelectWrapper.find('#pay_by_link_lifetime_chosen').addClass('hidden');
    $lifetimeSelectWrapper.find('select, input[type="hidden"]').prop('disabled', true);
    $lifetimeSelectWrapper.find('select').trigger('chosen:updated');
  }
}

function handleLifetimeFieldType() {
  var isLifetimeFieldAnInput = $('#payment-lifetime-input').prop('checked');

  if (isLifetimeFieldAnInput) {
    toggleLifetimeSelect(false);
    enableInputForLifetime();
  } else {
    toggleLifetimeSelect(true);
    disableInputForLifetime();
  }
}

function listenForSendByOptionChange() {
  var AVAILABLE_OPTIONS = ['send_link_by_none', 'send_link_by_email', 'send_link_by_sms'];
  AVAILABLE_OPTIONS.forEach(function (option) {
    if (exists($('#' + option))) {
      makeSendByFieldRequired();
      $('#' + option).on('change', function () {
        makeSendByFieldRequired();

        if ($('#send_link_by_none').is(':checked')) {
          $('#pay_by_link_submit').val(I18n.t('javascript.pay_by_link.generate_payment_link'));
        } else {
          $('#pay_by_link_submit').val(I18n.t('javascript.pay_by_link.send_payment_link'));
        }
      });
    }
  });
}

function listenForLifetimeSwitchChange() {
  var switchSelector = '.lifetime-field-options input';

  if (exists($(switchSelector))) {
    handleLifetimeFieldType();
    $(switchSelector).on('change', function () {
      handleLifetimeFieldType();
    });
  }
}

var PayByLink = {
  listenForSendByOptionChange: listenForSendByOptionChange,
  listenForLifetimeSwitchChange: listenForLifetimeSwitchChange,
  terminalChange: terminalChange
};
export default PayByLink;